import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  transaction: state.transaction.activeTransaction,
  pageUrl: state.table.detailUrl,
});

angular
  .module('myConsultApp')
  .controller(
    'transactionDetailController',
    (
      $ngRedux,
      $scope,
      $rootScope,
      $location,
      $http,
      $compile,
      $timeout,
      ENV,
      BrowserService,
      utilities,
    ) => {
      $scope.container_class = 'transaction-detail-container';
      $scope.retryStatus = true;
      $scope.processingFulfillment = false;
      $scope.processingPromoCode = [];
      $scope.isTransactionPromotionCodeActionMenu = false;
      $scope.promotionCodesScanning = false;
      $scope.deletingReceipt = false;

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.getTypeOfString = (value) => {
        if (typeof(value) === 'string' || typeof(value) == "boolean" || typeof(value) == "number" || !value) {
          return true;
        } else if (typeof(value) == 'object' && value.length == 0) {
          return true;
        } else {
          return false;
        }
      }

      $scope.generateTransactionPetDetailLink = (petId, userId) => {
        if ($location.$$url.startsWith('/admin/manage-users')) {
          return `${$rootScope.routes.user}/${userId}/pet-detail/${petId}`;
        }
        if ($location.$$url.startsWith('/admin/loyalty')) {
          return `${$rootScope.routes.transaction}/pet-detail/${petId}`;
        }
      };

      $scope.openOrganizationSubmissionProcessing = (submissionId, transactionId) => {
        var closeRoute = $rootScope.routes.user + '/' + $rootScope.userId;
        if ($location.$$url.startsWith('/admin/organizations/manage-organization-submissions')) {
          closeRoute = '/admin/organizations/manage-organization-submissions';
        }
        $scope.onOrganizationSubmissionProcessing(
          { 
            submissionId: submissionId, 
            closeRoute: closeRoute
          }
        );
      };

      $scope.showTransactionPromotionCodeActionMenu = () => {
        $scope.isTransactionPromotionCodeActionMenu = !$scope.isTransactionPromotionCodeActionMenu;
      };

      $scope.reScanTransactionForPromotionCodes = () => {
        $scope.promotionCodesScanning = true;
        $scope
          .reScanForCodes($http, ENV, $scope.transaction.id)
          .then(() => {
            $timeout(() => {
              $scope.promotionCodesScanning = false;
            });
          })
          .catch((error) => {
            $timeout(() => {
              $scope.promotionCodesScanning = false;
              $scope.showErrorModal('Promotion Code Scan', error.data.transaction);
            });
          });
      };

      $scope.deleteTransactionReceipt = (receiptId) => {
        $scope.deletingReceipt = true;
        $scope
        .deleteReceipt($http, ENV, $scope.transaction.id, receiptId)
        .then((res) => {
          $scope.$apply(() => {
            $scope.getTransaction($http, ENV, $scope.transaction.id);
            $scope.deletingReceipt = false;
          });
        });
      };

      $scope.createModal = async (content) => {
        angular.element(document.querySelector('.admin-overlay-modal')).remove();
        angular.element(document.querySelector('.admin-modal')).remove();
        const $body = $(content);
        const temp = $compile($body)($scope);
        await angular.element(document.body).append(temp);
        setTimeout(() => {
          angular.element(document.querySelector('.admin-modal')).addClass('display');
        }, 150);
      };

      $scope.closeDenialModal = () => {
        $scope.processingFulfillment = false;
        $scope.hideModal();
        $scope.clearDenialData();
      };

      $scope.clearDenialData = () => {
        $scope.transactionDenial = {
          reasons: null,
          selectedReason: '',
        };
      };

      $scope.openDenyTransactionModal = async () => {
        $scope.processingFulfillment = true;
        $scope.clearDenialData();

        $scope.getDenialReason($http, ENV).then((reasons) => {
          $scope.transactionDenial.reasons = reasons;
          $scope.createModal(
            `<div class="admin-modal transaction-deny">
              <h2>Deny Transaction</h2>
              <p>Please select a reason for denying this transaction:</p>
              <select
                ng-change="transactionDenialSelection()"
                ng-model="transactionDenial.selectedReason"
                ng-options="reason.id as reason.title for reason in transactionDenial.reasons"
              >
                <option value="">Choose an option</option>
              </select>
              <button
                type="submit"
                ng-disabled="!transactionDenial.selectedReason"
                ng-click="denyTransaction()"
              >
                Submit
              </button>
              <a
                class="cancel-button"
                ng-click="closeDenialModal()"
              >
                Cancel
              </a>
            </div>
            <div class="admin-overlay-modal">
          </div>`,
          );
        });
      };

      $scope.showErrorModal = (title, message) => {
        $scope.createModal(
          `<div class="admin-modal">
          <h2>${title}</h2>
          <p class="error">
            ${message}
          </p>
          <button ng-click="hideModal()">
            Ok
          </button>
        </div>
        <div class="admin-overlay-modal"></div>
        `,
        );
      };

      $scope.approveTransaction = () => {
        $scope.processingFulfillment = true;
        const transactionInfo = {
          transaction: {
            status: 'Approved',
          },
        };

        $scope
          .updateTransaction($http, ENV, $scope.transaction.id, transactionInfo)
          .then(() => {
            $timeout(() => {
              $scope.getTransaction($http, ENV, $scope.transaction.id);
              $rootScope.refreshLoyaltyStatistics();
              $scope.processingFulfillment = false;
              $rootScope.getDataByUrl($scope.pageUrl);
            });
          })
          .catch((error) => {
            $timeout(() => {
              $scope.getTransaction($http, ENV, $scope.transaction.id);
              $rootScope.refreshLoyaltyStatistics();
              $scope.processingFulfillment = false;
              $scope.showErrorModal('Transaction Approve', error.data.transaction.error);
            });
          });
      };

      $scope.denyTransaction = () => {
        $scope.processingFulfillment = true;
        const transactionInfo = {
          transaction: {
            status: 'Denied',
            denial_reason_id: $scope.transactionDenial.selectedReason,
          },
        };
        $scope.clearDenialData();
        $scope
          .updateTransaction($http, ENV, $scope.transaction.id, transactionInfo)
          .then(() => {
            $timeout(() => {
              $scope.hideModal();
              $scope.getTransaction($http, ENV, $scope.transaction.id);
              $rootScope.refreshLoyaltyStatistics();
              $scope.processingFulfillment = false;
              $rootScope.getDataByUrl($scope.pageUrl);
            });
          })
          .catch((error) => {
            $timeout(() => {
              $scope.getTransaction($http, ENV, $scope.transaction.id);
              $rootScope.refreshLoyaltyStatistics();
              $scope.processingFulfillment = false;
              $scope.showErrorModal('Transaction Deny', error.data.transaction.error);
            });
          });
      };

      $scope.retryTransaction = () => {
        $scope
          .updateTransaction($http, ENV, $scope.transaction.id)
          .then(() => {
            $timeout(() => {
              $scope.getTransaction($http, ENV, $scope.transaction.id);
              $rootScope.refreshLoyaltyStatistics();
              $rootScope.getDataByUrl($scope.pageUrl);
            });
          })
          .catch((error) => {
            $timeout(() => {
              $scope.getTransaction($http, ENV, $scope.transaction.id);
              $rootScope.refreshLoyaltyStatistics();
              $scope.showErrorModal('Transaction Retry', error.data.transaction.error);
            });
          });
      };

      $scope.applyTransactionCode = (codeId, codeIndex) => {
        $scope.processingPromoCode[codeIndex] = true;
        $scope
          .applyCode($http, ENV, $scope.transaction.id, codeId)
          .then(() => {
            $timeout(() => {
              $scope.getTransaction($http, ENV, $scope.transaction.id);
              $rootScope.refreshLoyaltyStatistics();
              $scope.processingPromoCode[codeIndex] = false;
              $rootScope.getDataByUrl($scope.pageUrl);
            });
          })
          .catch((error) => {
            $timeout(() => {
              $scope.getTransaction($http, ENV, $scope.transaction.id);
              $rootScope.refreshLoyaltyStatistics();
              $scope.processingPromoCode[codeIndex] = false;
              $scope.showErrorModal('Promotion Code Apply', error.data.transaction);
            });
          });
      };

      $scope.retryTransactionCode = (activityId, promoCodeId, codeIndex) => {
        $scope.processingPromoCode[codeIndex] = true;
        $scope
          .retryCode($http, ENV, activityId)
          .then(() => {
            $timeout(() => {
              $scope.getTransaction($http, ENV, $scope.transaction.id);
              $rootScope.refreshLoyaltyStatistics();
              $scope.processingPromoCode[codeIndex] = false;
              $rootScope.getDataByUrl($scope.pageUrl);
            });
          })
          .catch((error) => {
            $timeout(() => {
              $scope.getTransaction($http, ENV, $scope.transaction.id);
              $rootScope.refreshLoyaltyStatistics();
              $scope.processingPromoCode[codeIndex] = false;
              if (!$scope.viewMore.includes(promoCodeId)) {
                $scope.viewMore.push(promoCodeId);
              }
              $scope.showErrorModal('Promotion Code Retry', error.data.transaction);
            });
          });
      };

      $scope.toggleView = (id) => {
        if ($scope.viewMore.includes(id)) {
          $scope.viewMore = $scope.viewMore.filter((elem) => elem !== id);
        } else {
          $scope.viewMore = [...$scope.viewMore, id];
        }
      };

      $scope.getReceiptUrl = (url) => {
        const myNewTab = BrowserService.openNewTab();
        utilities.getResourceUrl(url).then((response) => {
          BrowserService.updateTabLocation(response.receipts.tokenized_receipt_url, myNewTab);
        });
      };

      $scope.close = () => {
        $rootScope.closeComponent();
      };

      $scope.checkRetryStatus = () => {
        let dupliateImageError = false;

        if ($scope.transaction.status.id === -8) {
          angular.forEach($scope.transaction.error_log, (error) => {
            if (error.error.toLowerCase().includes('duplicate receipt_image_id')) {
              dupliateImageError = true;
            }
          });
        }

        $scope.retryStatus = !dupliateImageError;
      };

      $(document).on('click', (event) => {
        const settingEle = $('.transaction-promotion-codes .header-actions');

        if (settingEle !== event.target && !settingEle.has(event.target).length) {
          $scope.$apply(() => {
            $scope.isTransactionPromotionCodeActionMenu = false;
          });
        }
      });

      const activeTransactionListener = $scope.$watch('transaction', () => {
        if ($scope?.transaction) {
          $scope.checkRetryStatus();
          $scope.processingPromoCode = [];
          angular.forEach($scope.transaction.promotion_codes, (promo_code, index) => {
            $scope.processingPromoCode[index] = false;
          });
          $scope.viewMore = [];
        }
      });

      $scope.init();
      $scope.$on('$destroy', () => {
        $scope.clearTransaction();
        $scope.unsubscribe();
        $scope.closeDenialModal();
        activeTransactionListener();
      });
    },
  )
  .directive('transactionDetail', () => {
    return {
      templateUrl: 'templates/v2/transaction-detail.html',
    };
  });
